import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { useAuthentication } from '@/hooks/auth/useAuthentication';
import { ProfessionalMyPageTop } from '@/pages/mypage/professional/ProfessionalMyPageTop';
import { professionalProfile } from '@/utils/resources/profile/profileType';
export const ProfessionalMyPageTopAuth = () => {
    // 認証周りの判定取得
    const { message: authRedirectMessage, profile: rawProfile, redirectTo: authRedirectTo, } = useAuthentication({ isProfessional: true });
    const profile = professionalProfile(rawProfile);
    // リダイレクト: ユーザー認証
    if (authRedirectTo || !profile) {
        return _jsx(CustomRedirect, { message: authRedirectMessage, to: authRedirectTo });
    }
    return _jsx(ProfessionalMyPageTop, { profile: profile });
};
